import { useState } from 'react';

const SideBarSearch = ({ placeholder = 'Search...', onSearch }) => {
    const [searchQuery, setSearchQuery] = useState('');

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        if (onSearch) {
            onSearch(value);
        }
    };

    return (
        <>
            <i className="fa-solid fa-search"></i>
            <input
                type="text"
                className="search-input"
                placeholder={placeholder}
                value={searchQuery}
                onChange={handleInputChange}
            />
        </>
    );
};

export default SideBarSearch;
